import React from "react"
import { Field } from "../../ui"

const IntroSection = ({ domRef, info, value, className, open, onSelect, ...props }) => {
    if (!value) return null

    const classes = `${className || ""} ${open?"open":""}`
    
    return (
        <div ref={domRef} className={classes} onClick={onSelect} {...props}>
            <Field info={info} field="img" noadmin bg _nowrap noth preload />
            <Field info={info} field="text" />
        </div>
    )
}
export default React.memo(IntroSection)
